export type JourneySwitchModal = 'mta-vehicle' | 'mta' | '';

/**
 * Determines which cancellation reason modal should be displayed - _specifically on the cancellation date page._
 * @param reason The reason for cancellation.
 * @param modalPermitted Whether the modal is permitted to be shown.
 * @param mtaPermitted Whether the MTA modal is permitted to be shown.
 * @returns The type of modal to display.
 */
export const determineCancellationReasonModal = (reason: string, mtaPermitted: boolean): JourneySwitchModal => {
	let modal: JourneySwitchModal = '';
	if (reason === 'VEHICLE_SOLD' && mtaPermitted) {
		modal = 'mta-vehicle';
	}
	if (reason === 'CHEAPER_NO_AP' && mtaPermitted) {
		modal = 'mta';
	}

	return modal;
};
